<template>
  <div>
    <div>
      <el-table
        :data="totalMessageList"
        border
        style="width: 100%">
        <el-table-column
          align="center"
          v-for="(message,mi) in totalMessageTitle"
          :key="mi"
          :prop="message.value"
          :label="message.label">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px">
      <el-row :gutter="12">
        <el-col :span="6" v-for="(message,index) in operateMessageList" :key="index">
          <el-card shadow="hover">
            <el-descriptions  direction="vertical" :column="1" border class="card-center">
              <el-descriptions-item content-class-name="card-error"  :label="message.label">
                <div v-if="message.label === '尚未审核'">
                  <el-button type="text" @click="handleCard('借用')">
                    <span style="color: #ee6868">{{ message.value.split(',')[0] }}台 </span>借用
                  </el-button>
                  <span> / </span>
                  <el-button type="text" @click="handleCard('归还')">
                    <span style="color: #ee6868">{{ message.value.split(',')[1] }}台 </span>归还
                  </el-button>
                </div>
                <div v-else> 
                  <span>{{ message.value }}台</span>
                  <el-button type="text" @click="handleCard(message.label)">（处理）</el-button>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 20px">
      <div class="echart-box" ref="borrowingFrequency"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      totalMessageTitle: [
        {label: '总数',value: 'total'},
        {label: '在用数',value: 'using'},
        {label: '借用数',value: 'borrow'},
        {label: '停用数',value: 'used'},
        {label: '报废数',value: 'scrap'},
        {label: '待检数',value: 'forcheck'},
        {label: '待修数',value: 'forfix'},
      ],
      totalMessageList:[
        {'total': '','using': '','borrow': '','used': '','scrap': '','forcheck': '','forfix':''}
      ],
      operateMessageList: [
        {label: '尚未审核',value: '',operate: ''},
        {label: '超长借出',value: '',operate: ''},
        {label: '还有30天到期',value: '',operate: 'card-warning'},
        {label: '超期未检',value: '',operate: ''},
      ],
      frequencyOption: {
        title:{text:'在用仪器数量排行统计'},
        xAxis: {type: 'category',data: []},
        yAxis: {type: 'value'},
        series: [
          {
            data: [],
            type: 'bar',
            label: {
              show: true, // 显示标签
              position: 'top' // 标签位置
            },
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)',
            }
          }
        ]
      }
    }
  },
  mounted(){
    this.getAlertCount();
    this.getStatistics();
  },
  methods:{
    async getStatistics(){
      let r = await this.$equipmentdata.getStatistics();
      let names = [];
      let values = [];
      r.forEach((item,index) => {
        names.push(item.name);
        values.push(item.aimCount + "");
      })
      this.frequencyOption.xAxis.data = names;
      this.frequencyOption.series[0].data = values;
      const dom = this.$refs.borrowingFrequency;
      const borrowingFrequency = this.$echarts.init(dom);
      borrowingFrequency.setOption(this.frequencyOption);
    },
    async getAlertCount(){
      let r = await this.$equipmentdata.getAlertCount(JSON.stringify(['machineStatusCount','verifyAlert','verifyOverAlert','borrowAdminAlert','auditCount']));
      this.operateMessageList = [
        {label: '尚未审核',value: r.auditCount,operate: ''},
        {label: '超长借出',value: r.borrowAdminAlert,operate: ''},
        {label: '还有30天到期',value: r.verifyAlert,operate: ''},
        {label: '超期未检',value: r.verifyOverAlert,operate: ''},
      ]
      this.totalMessageList = [
        r.machineStatusCount
      ]
    },
    async handleCard(label){
      let that = this.$root.$children[0].$children[1].$children[0];
      if(label === '借用' || label === '归还'){
        await this.$router.push({
          name: 'InstrumentAudit',
          params: {
            auditType: label
          }
        });
      }else if(label === '还有30天到期'){
        that.$set(that,'operationDialogVisible',true);
        that.$set(that,'alertType','verifyAlert');
        that.$set(that,'dialogTitle','还有30天到期');
      }else if(label === '超期未检'){
        that.$set(that,'operationDialogVisible',true);
        that.$set(that,'alertType','verifyOverAlert');
        that.$set(that,'dialogTitle','超期未检');
      }else if(label === '超长借出'){
        that.$set(that,'alertType','overBorrow');
        that.$set(that,'operationDialogVisible',true);
        that.$set(that,'dialogTitle','超长借出');
      }
    },
  },

}
</script>

<style type="text/css">
.card-center th,td{
  text-align: center !important;
}
.echart-box{
  width: 100%;
  height: 350px;
}
.card-error{
  color: #F56C6C
}
.card-warning{
  color: #E6A23C
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Statistics.vue